export const APP_TITLE = "学習者用デジタル版資料集（超教科書クラウド） シリアルコード通知シート";